import React from "react";
import { BrowserRouter as Router, Routes, Route, Link as RouterLink } from "react-router-dom";
import { Box, Flex, Link, Container } from "@chakra-ui/react";
import AuthButton from "./components/AuthButton";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import Home from "./pages/Home";
import MyBookings from "./pages/MyBookings";
import EventForm from "./pages/EventForm";
import EventDetails from "./pages/EventDetails";
import CancelReservation from "./pages/CancelReservation";
import CancelWaitingList from "./pages/CancelWaitingList";
import RespondWaitingList from "./pages/RespondWaitingList";
import EditReservation from "./pages/EditReservation";
import EditWaitingList from "./pages/EditWaitingList";

// Layout component with navigation bar
const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box minH="100vh" bg="gray.900">
      <Box
        as="nav"
        bg="gray.800"
        borderBottom="1px"
        borderColor="gray.700"
        position="sticky"
        top={0}
        zIndex={100}
      >
        <Container maxW="container.xl">
          <Flex h="16" align="center" justify="space-between">
            <Link
              as={RouterLink}
              to="/"
              fontSize="lg"
              fontWeight="bold"
              color="white"
              _hover={{ textDecoration: "none", color: "teal.300" }}
            >
              Scarpetta Home Restaurant
            </Link>
            <AuthButton />
          </Flex>
        </Container>
      </Box>

      <Box as="main" py={6}>
        <Container maxW="container.xl">
          {children}
        </Container>
      </Box>
    </Box>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page - no navigation bar */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Pages with navigation bar */}
        <Route path="/serate" element={<AppLayout><Home /></AppLayout>} />
        <Route path="/serate/prenota/:eventoSlug" element={<AppLayout><Home /></AppLayout>} />
        <Route path="/serate/gift-card/:giftcard" element={<AppLayout><Home /></AppLayout>} />
        <Route path="/le-mie-prenotazioni" element={<MyBookings />} />
        
        {/* Legacy routes - redirect to new paths */}
        <Route path="/prenota/:eventoSlug" element={<AppLayout><Home /></AppLayout>} />
        <Route path="/gift-card/:giftcard" element={<AppLayout><Home /></AppLayout>} />
        
        <Route path="/annulla/:prenotazioneId" element={<AppLayout><CancelReservation /></AppLayout>} />
        <Route path="/annulla-attesa/:listaAttesaId" element={<AppLayout><CancelWaitingList /></AppLayout>} />
        <Route path="/rispondi-attesa/:listaAttesaId/:action" element={<AppLayout><RespondWaitingList /></AppLayout>} />
        <Route path="/modifica/:prenotazioneId" element={<AppLayout><EditReservation /></AppLayout>} />
        <Route path="/modifica-attesa/:listaAttesaId" element={<AppLayout><EditWaitingList /></AppLayout>} />
        <Route
          path="/eventi/nuovo"
          element={
            <AppLayout>
              <ProtectedRoute>
                <EventForm />
              </ProtectedRoute>
            </AppLayout>
          }
        />
        <Route
          path="/eventi/:id"
          element={
            <AppLayout>
              <ProtectedRoute>
                <EventForm />
              </ProtectedRoute>
            </AppLayout>
          }
        />
        <Route
          path="/eventi/:id/prenotazioni"
          element={
            <AppLayout>
              <ProtectedRoute>
                <EventDetails />
              </ProtectedRoute>
            </AppLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
